import {
  adaptCourseToApi,
  adaptCourseToCreateApi,
  adaptCourseToStore,
  adaptCoursesToStore,
} from './adapters/courseAdapter'

import CONSTANTS from '@/constants'
import { BUSINESS_PYTHON, CONTENT, CONTENT_BACKOFFICE } from '@/services/axios.config'
import { buildHeaders } from './utils/build_headers'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'
import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

const services = [
  {
    name: 'listCourses',
    method: 'get',
    url: (params) => `/courses${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptCoursesToStore,
  },
  {
    name: 'getCoursesWithoutAdapter',
    method: 'get',
    url: (params) => `/courses${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'getCourse',
    method: 'get',
    url: (params) => `/courses/${params.courseId}`,
    resolver: adaptCourseToStore
  },
  {
    name: 'createCourse',
    method: 'post',
    url: () => `/courses`,
    data: (params) => {
      return adaptCourseToCreateApi(params)
    },
    resolver: adaptCourseToStore
  },
  {
    name: 'editCourse',
    method: 'put',
    url: (params) => `/courses/${params.courseId}`,
    data: (params) => {
      return adaptCourseToApi(params)
    },
    resolver: adaptCourseToStore
  },
  {
    name: 'patchCourse',
    method: 'patch',
    url: (params) => `/courses/${params.courseId}`,
    data: (params) => {
      return adaptCourseToApi(params)
    },
    resolver: adaptCourseToStore
  },
  {
    name: 'patchCourseAccessType',
    method: 'patch',
    url: (params) => `/courses/${params.courseId}`,
    data: (params) => {
      return {
        audience_type: params.audience_type,
      }
    },
  },
  {
    name: 'uploadFile',
    method: 'post',
    url: (params) => `/courses/${params.courseId}/csv-import?company=${params.company}`,
    headersFactory: buildHeaders({
      'Content-Type': undefined
    }),
    data: (params) => {
      return params.file
    }
  },{
    name: 'getFile',
    method: 'get',
    url: (params) => `/courses/${params.courseId}/files/${params.fileId}`
  }, {
    name: 'createFile',
    method: 'post',
    url: (params) => `/courses/${params.courseId}/files`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url
      }
    }
  }, {
    name: 'editFile',
    method: 'put',
    url: (params) => `/courses/${params.courseId}/files/${params.file.id}`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url
      }
    }
  }, {
    name: 'deleteFile',
    method: 'delete',
    url: (params) => `/courses/${params.courseId}/files/${params.file.id}`
  }
]

const backofficeServices = [
  {
    name: 'assignCourseBusinessAccounts',
    method: 'post',
    url: () => `/custom-content/assign-accounts`,
    data: (params) => {
      return {
        content_id: params.courseId,
        content_type: CONSTANTS.CONTENT_TYPES.COURSE,
        business_account_ids: params.business_account_ids,
      }
    },
  },
  {
    name: 'removeCourseBusinessAccounts',
    method: 'post',
    url: () => `/custom-content/unassign-accounts`,
    data: (params) => {
      return {
        content_id: params.courseId,
        content_type: CONSTANTS.CONTENT_TYPES.COURSE,
        business_account_ids: params.business_account_ids,
      }
    },
  },
]

const businessApiServices = [
  {
    name: 'listBusinessAccounts',
    method: 'get',
    url: (params) => `/accounts${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'getBusinessAccount',
    method: 'get',
    url: (params) => `/accounts/${params.accountId}`,
  },
]

export const {
  getCourse,
  listCourses,
  createCourse,
  editCourse,
  patchCourse,
  patchCourseAccessType,
  uploadFile,
  getFile,
  createFile,
  editFile,
  deleteFile,
  getCoursesWithoutAdapter,
} = buildServices(CONTENT, services)

export const {
  listBusinessAccounts,
  getBusinessAccount,
} = buildServices(BUSINESS_PYTHON, businessApiServices)

export const {
  assignCourseBusinessAccounts,
  removeCourseBusinessAccounts,
} = buildServices(CONTENT_BACKOFFICE, backofficeServices)
